import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"

export const Rooms_s = styled.div`
  .p-paginator {
    bottom: 30px;
  }
`

export const RoomTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .carousel-multi-row {
    > div:nth-child(2) > input {
      width: 135px;
    }
    input.year-input {
      width: 50px;
    }
    &.rooms-area-detailed > div:nth-child(1) > input {
      width: 150px;
    }
    &.rooms-area-detailed > div:nth-child(3) > input {
      width: 135px;
    }
  }

  input[data-field="amt"], input[data-field="rooms"], input[data-field="area"], input[data-field="occup"] {
    width: 135px;
  }

  // footer
  .selection-count {
    bottom: 86px;
    font-size: smaller;
    left: 5px;
    position: absolute;
    z-index: 999;
  }
`
